import NavBar from '../components/NavBar'
import HeroSection from '../components/APIIntegrationAutomation/HeroSection'
import Footer from '../components/Footer'
import ProcessSection from '../components/APIIntegrationAutomation/ProcessSection'
import TechStackMarquee from '../components/APIIntegrationAutomation/TechStackMarquee'
import ContactMap from '../components/ContactMap'

const APIIntegrationAutomation = () => {
	return (
		<div className="min-h-screen">
			<NavBar />
			<HeroSection />
			<ProcessSection />
			<TechStackMarquee />
			<ContactMap />
			<Footer />
		</div>
	)
}

export default APIIntegrationAutomation